module.exports = __webpack_public_path__ + "img/01.bddf442b.jpg";